import { addHours, setSeconds } from 'date-fns';
import { atom } from 'jotai';
import { LiveStateUpdate } from '../util/Events/Messages';

export const REPLAY_LAST_EVENTS = atom<LiveStateUpdate[]>([]);

export const REPLAY_START = atom(setSeconds(addHours(new Date(), -2), 0));
export const REPLAY_NOW = atom(setSeconds(addHours(new Date(), -2), 0));
export const REPLAY_PLAYING = atom(false);
export const REPLAY_SECONDS_PER_SECOND = atom(8);

export const REPLAY_MESSAGES = atom<LiveStateUpdate[]>([]);
export const NEW_REPLAY_MESSAGES = atom<LiveStateUpdate[]>([]);
